import React from "react";
import StepHeader from "../../Evaluation/StepHeader";
import { Config } from "../../../model_gen/config";
import { Card, CardContent } from "../../ui/card";
import { Separator } from "../../ui/separator";

interface TestRunData {
  description?: string;
  config?: Config;
}

interface TestRunReviewProps {
  testRunData: TestRunData;
  testSetId: number;
}

const TestRunReview: React.FC<TestRunReviewProps> = ({ testRunData, testSetId }) => {
  return (
    <div className="space-y-6 w-full">
      <StepHeader
        title="Review Test Run"
        description="Review your test run configuration before creating"
      />

      <Card className="border-border">
        <CardContent className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-1">
              <div className="text-xs text-muted-foreground">Description</div>
              <div className="text-sm text-foreground">
                {testRunData.description || "No description provided"}
              </div>
            </div>
            <div className="space-y-1">
              <div className="text-xs text-muted-foreground">Test Set ID</div>
              <div className="text-sm text-foreground">{testSetId}</div>
            </div>
            <div className="space-y-1">
              <div className="text-xs text-muted-foreground">Model</div>
              <div className="text-sm text-foreground">
                {testRunData.config?.model || "No model selected"}
              </div>
            </div>
          </div>

          <Separator className="border-border" />

          <div className="space-y-1">
            <div className="text-xs text-muted-foreground">Additional Details</div>
            <div className="text-sm text-muted-foreground">
              Configuration values and advanced options will be applied from the configuration step.
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TestRunReview;
